import React from "react";
import { usePublicPageSection } from "../../../../hooks/usePublicPageSection";
import { useLanguage } from "../../../../context/LanguageContext";
import "./Hero.css";

const requireField = (fields, key) => {
  const value = fields?.[key];
  if (value == null || String(value).trim() === "") {
    throw new Error(`Report hero field "${key}" is missing from the API response.`);
  }
  return value;
};

const buildModel = (section) => {
  const f = section.fields || {};
  return {
    secureLabel: requireField(f, "secureLabel"),
    secureText: requireField(f, "secureText"),
    title: requireField(f, "title"),
    subtitle: requireField(f, "subtitle"),
  };
};

const Hero = () => {
  const { meta } = useLanguage();
  const { model, error, isLoading } = usePublicPageSection("report", "hero", buildModel);

  if (isLoading) {
    return (
      <section className="report-hero" dir={meta.dir}>
        <div className="report-hero__content">
          <p style={{ color: "#64748b", fontSize: 14 }}>Loading…</p>
        </div>
      </section>
    );
  }

  if (error || !model) {
    return (
      <section className="report-hero" dir={meta.dir}>
        <div className="report-hero__content">
          <p style={{ color: "#b91c1c", fontSize: 14 }}>
            {error || "Report hero unavailable."}
          </p>
        </div>
      </section>
    );
  }

  return (
    <section className="report-hero" dir={meta.dir}>
      <div className="report-hero__content">
        <div
          className="report-hero__secure"
          aria-label={`${model.secureLabel} ${model.secureText}`}
        >
          <span className="report-hero__secure-label">{model.secureLabel}</span>
          <span className="report-hero__secure-text">{model.secureText}</span>
        </div>

        <h1 className="report-hero__title">{model.title}</h1>

        <p className="report-hero__subtitle">{model.subtitle}</p>
      </div>
    </section>
  );
};

export default Hero;
